<template>
  <el-dialog title="角色账号" :visible.sync="dialogAccountVisible">
    <el-table :data="accountData">
      <el-table-column
        property="nickName"
        label="昵称"
        center
      ></el-table-column>
      <el-table-column property="headImg" label="头像" center>
        <template slot-scope="scope">
          <img :src="scope.row.headImg" style="width: 60px; height: 60px" />
        </template>
      </el-table-column>
      <el-table-column
        property="userCode"
        label="用户编号"
        center
      ></el-table-column>
      <el-table-column property="remind" label="记住" center></el-table-column>
      <el-table-column
        property="roleName"
        label="权限名称"
        center
      ></el-table-column>
      <el-table-column property="isRealName" label="是否实名" center>
        <template slot-scope="scope">
          {{ scope.row.isRealName ? '是' : '否' }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="账号状态">
                <template slot-scope="scope">
                    <el-button :type="scope.row.accountStatus === 1?'primary':'danger'" size="mini">{{scope.row.accountStatus==1?'在用':'停用'}}</el-button>
                </template>
            </el-table-column> -->
    </el-table>
    <div></div>
  </el-dialog>
</template>
<script>
export default {
  props: ['accountData'],
  data() {
    return {
      dialogAccountVisible: false,
    };
  },
};
</script>